import { createContext } from 'react';

export const AddTooltipDispatch = createContext(null);

export const HIDE_ADD_TOOLTIPE_BUTTON = '@@ORPHEUS_EDITOR/HIDE_ADD_TOOLTIPE_BUTTON';
export const HIDE_ADD_TOOLTIP_MENU = '@@ORPHEUS_EDITOR/HIDE_ADD_TOOLTIP_MENU';
export const SHOW_ADD_TOOLTIP_BUTTON = '@@ORPHEUS_EDITOR/SHOW_ADD_TOOLTIP_BUTTON';
export const SHOW_ADD_TOOLTIP_MENU = '@@ORPHEUS_EDITOR/SHOW_ADD_TOOLTIP_MENU';